import React from 'react';

function ResearcherT() {
  return <div></div>;
}

export default ResearcherT;
